import * as React from "react";
import type { SVGProps } from "react";
const ExitedFaceSvg = (props: SVGProps<SVGSVGElement>) => (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_437_10017)">
            <path d="M7 13C10.3138 13 13 10.3138 13 7C13 3.68629 10.3138 1 7 1C3.68629 1 1 3.68629 1 7C1 10.3138 3.68629 13 7 13Z" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M4.92315 5.15392C4.7957 5.15392 4.69238 5.0506 4.69238 4.92315C4.69238 4.7957 4.7957 4.69238 4.92315 4.69238" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M4.92285 5.15392C5.0503 5.15392 5.15362 5.0506 5.15362 4.92315C5.15362 4.7957 5.0503 4.69238 4.92285 4.69238" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M9.07696 5.15392C8.94951 5.15392 8.84619 5.0506 8.84619 4.92315C8.84619 4.7957 8.94951 4.69238 9.07696 4.69238" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M9.07715 5.15392C9.2046 5.15392 9.30792 5.0506 9.30792 4.92315C9.30792 4.7957 9.2046 4.69238 9.07715 4.69238" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M7.0003 10.6927C8.78461 10.6927 10.2311 9.24622 10.2311 7.46191H3.76953C3.76953 9.24622 5.21599 10.6927 7.0003 10.6927Z" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
        </g>
        <defs>
            <clipPath id="clip0_437_10017">
                <rect width="14" height="14" fill="white" />
            </clipPath>
        </defs>
    </svg>


);
export default ExitedFaceSvg;
